var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "patternH",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M569.16,378.17c-1.99,1.27-4.16,3.74-5.91,3.47-1.82-.28-4.18-3.07-4.48-5.04-.19-1.25,2.89-4.19,4.57-4.24,1.91-.05,3.89,2.27,5.84,3.56,0,.75-.01,1.5-.02,2.25h0Z",
    className: "patternColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M542.12,222.76c-1.23-1.97-3.66-4.15-3.36-5.86.32-1.84,3.06-4.26,4.98-4.5,1.34-.17,4.32,2.89,4.34,4.53.02,1.94-2.36,3.9-3.71,5.85-.75,0-1.5-.02-2.26-.03h.01Z",
    className: "patternColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M408.34,247.6c-1.14-2.05-3.33-4.24-3.1-6.12.2-1.64,3.06-4.05,4.88-4.18,3.48-.24,5.52,2.39,4.37,5.89-.6,1.83-2.65,3.19-4.04,4.76-.7-.12-1.4-.23-2.1-.35h0Z",
    className: "patternColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M605.3,552.86c-4.34-.61-5.81-2.1-5.86-5.15-.06-3.32,1.65-5.89,4.79-5.35,1.88.32,4.33,3.05,4.64,5,.25,1.61-2.27,3.65-3.56,5.5h-.01Z",
    className: "patternColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.19,283.11c.27,3.36-1.14,5.06-4.51,5.24-3.63.2-4.91-2.5-4.95-4.98-.04-2.42,1.01-5.42,4.74-5,2.86.32,5.28,1.15,4.72,4.74h0Z",
    className: "patternColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M551.14,335.01c4.28.73,6.16,1.71,6.15,5.34,0,3.28-1.26,4.97-4.44,5.34-3.55.42-5.13-2.18-5.05-4.72.06-2.02,2.15-3.98,3.35-5.96h-.01Z",
    className: "patternColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M251.82,496.19c4.47,1.11,5.51,2.98,5.45,6.18-.07,3.59-2.41,4.42-5.1,4.56-3.5.18-4.71-2.78-4.33-5.24.31-1.99,2.58-3.68,3.97-5.5h.01Z",
    className: "patternColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M557.99,315.24c-1.84,1.42-3.75,4.03-5.51,3.95-1.81-.09-4.79-2.75-4.87-4.41-.08-1.67,2.58-4.61,4.39-4.91,1.74-.29,3.92,2.09,5.9,3.29.03.69.07,1.39.1,2.08h-.01Z",
    className: "patternColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M488.47,236.92c2.34,3.43,4.64,5.3,4.7,7.24.1,3.02-2.28,5-5.66,4.6-3.21-.39-4.88-2.51-3.95-5.52.57-1.85,2.48-3.29,4.91-6.32Z",
    className: "patternColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M311.01,315.33c-1.25-1.69-3.76-3.68-3.45-5.01.47-2.04,2.71-4.87,4.52-5.13,2.52-.36,5.4,1.1,5.17,5-.2,3.47-1.93,4.66-6.24,5.14Z",
    className: "patternColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M469.19,348.84c-.46,4.17-1.84,6.31-4.91,5.52-2.14-.55-5.12-2.33-5.54-4.09-.68-2.85,1.78-5.56,4.82-5.29,1.98.18,3.76,2.5,5.63,3.86h0Z",
    className: "patternColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M450.24,175.34c-1.43-1.83-4.36-4.14-3.96-5.38.68-2.13,3.44-3.6,5.33-5.34,1.41,1.91,3.5,3.65,4.05,5.78.79,3.04-1.27,4.5-5.42,4.94h0Z",
    className: "patternColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M305.25,415.38c-4.03-.83-6.33-2.12-5.44-5.21.6-2.11,2.55-5,4.31-5.33,2.88-.54,5.65,1.9,5.25,5.02-.25,1.98-2.67,3.69-4.12,5.52Z",
    className: "patternColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M481.58,409.88c4.26,1.08,6.38,2.97,5.42,5.93-.64,1.95-3.24,3.26-4.97,4.86-1.59-1.77-4.31-3.46-4.44-5.33-.12-1.72,2.55-3.64,3.99-5.47h0Z",
    className: "patternColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M272.57,592.72c1.85-1.42,3.95-4.19,5.5-3.91,2,.35,3.56,3.15,5.31,4.89-1.84,1.54-3.46,3.82-5.57,4.46-2.97.9-4.62-1.1-5.24-5.44h0Z",
    className: "patternColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M285.94,605.71c-.4-3.15.91-5.07,4.3-4.93,3.14.12,4.55,1.74,4.45,5.09-.09,3.15-.81,4.99-4.43,4.89-3.46-.09-4.75-1.69-4.33-5.05h0Z",
    className: "patternColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M508.41,568.96c.25,3.46-1.76,5.06-4.5,4.2-2.07-.65-3.65-2.89-5.45-4.42,1.69-1.72,3.25-4.67,5.11-4.87,2.58-.28,5.46,1.43,4.84,5.09h0Z",
    className: "patternColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M435.04,657.84c-4.26-.63-6.21-2.41-5.37-5.24.62-2.08,3.01-3.62,4.61-5.41,1.58,1.88,3.98,3.58,4.44,5.69.29,1.32-2.35,3.28-3.68,4.95h0Z",
    className: "patternColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M305.82,247.58c.27,3.72-2.21,5.44-4.84,4.84-1.98-.45-3.43-3.16-5.12-4.87,1.76-1.61,3.35-4.24,5.34-4.59,2.57-.45,5.2,1.17,4.63,4.62h-.01Z",
    className: "patternColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M359.39,602.89c-3.18,2.22-5.19,4.66-6.62,4.36-2.06-.43-3.69-2.87-5.5-4.45,1.93-1.7,3.63-4.13,5.87-4.81,1.14-.35,3.23,2.42,6.26,4.9h-.01Z",
    className: "patternColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M576.99,541.51c-2.67-.78-4.85-.77-5.66-1.82-.85-1.1-1.07-3.73-.3-4.77,1.03-1.41,3.19-2.46,4.99-2.68,1.06-.13,3.1,1.43,3.4,2.57.82,3.14-.09,5.91-2.44,6.7h0Z",
    className: "patternColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M177.68,584.18c1.96-1.15,4.06-3.39,5.82-3.14,1.8.25,3.26,2.94,4.86,4.56-1.72,1.69-3.29,4.48-5.22,4.75-1.65.23-3.7-2.42-5.57-3.79.03-.79.06-1.59.1-2.38h0Z",
    className: "patternColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M235.82,348.85c.14,3.4-1.6,5.26-4.48,4.28-2.04-.69-3.54-2.98-5.28-4.55,1.71-1.49,3.25-3.88,5.18-4.26,2.89-.57,5.02,1.25,4.58,4.53Z",
    className: "patternColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M222.83,462.86c-4.31-.62-6.31-2.16-5.45-5.14.61-2.1,2.74-3.76,4.18-5.61,1.84,1.59,4.96,3.05,5.16,4.82.2,1.82-2.48,3.95-3.89,5.94h0Z",
    className: "patternColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M550.85,476.42c-.18-3.66,2.04-5.05,4.7-4.2,1.89.6,3.24,2.89,4.83,4.43-1.65,1.62-3.19,4.41-4.97,4.57-2.41.22-5.21-1.4-4.55-4.79h-.01Z",
    className: "patternColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M367.27,221.84c-.31-2.87.75-4.79,4.02-4.76,3.19.03,4.98,1.68,4.83,4.9-.13,2.79-.71,5.24-4.53,5.09-3.55-.14-4.68-1.9-4.32-5.23h0Z",
    className: "patternColor"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M467.4,522.8c1.74-1.1,3.35-2.72,5.24-3.19,3.03-.75,5.14,1.39,4.67,4.11-.34,1.98-2.51,4.9-4.12,5.07-1.77.19-3.83-2.27-5.77-3.58-.01-.8-.02-1.61-.03-2.41h0Z",
    className: "patternColor"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M297.24,273.92c-.18-3.43,1.5-4.43,4.55-4.47,3.39-.05,4.77,2.3,4.3,4.61-.38,1.89-2.71,4.55-4.42,4.75-2.6.3-4.97-1.61-4.43-4.88h0Z",
    className: "patternColor"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M297.87,148.64c-1.15,1.96-1.85,4.74-3.56,5.66-1.69.9-4.38-.08-6.64-.23-.03-.59-.06-1.18-.09-1.77,2.77-1.67,5.53-3.35,8.3-5.02.66.46,1.33.91,1.99,1.37h0Z",
    className: "patternColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternH);
export default __webpack_public_path__ + "static/media/patternH.8014073d0b19da4f35f882ce38d19e6e.svg";
export { ForwardRef as ReactComponent };